// @ts-nocheck
/* eslint-disable */
import MD5 from './md5'
import { encode, decode } from './base64';
import { equalEp } from './encryption'

const decry = (url = '') => {
    console.log('decry:', url)
    let d = url.split('&d=')[1]
    let ep = url.split('&d=')[0].split('&ep=')[1]
    if (d && ep) {
        let e = decodeURIComponent(url.split('&ep=')[0] || '').split('&').map(e => e.split('=')[1])
        let username = '', nickname = '', password = '', type = '', ispassword = '', token = '', avatar = '', job = '';

        if (d % 2) {
            username = e[0] || '';
            nickname = e[1] || '';
            password = decode(e[2])?.split('').reverse().join('') || '';
            type = e[3] || '';
            ispassword = e[4] || '';
            token = e[5]?.split('').reverse().join('') || '';
            avatar = decode(e[6]) || ''
            job = decode(e[7])?.split('').reverse().join('') || '';
        } else {
            job = decode(e[7])?.split('').reverse().join('') || '';
            avatar = decode(e[6]) || ''
            username = e[5] || '';
            nickname = e[4] || '';
            password = decode(e[3])?.split('').reverse().join('') || '';
            type = e[2] || '';
            ispassword = e[1] || '';
            token = e[0].split('')?.reverse().join('') || '';
        }
        console.log('ep:', ep)
        if (ep == equalEp({ username, nickname, password, type, ispassword, token, avatar, job, d })) {
            console.log('decry success:', username, nickname, password, type, ispassword, token, job, d)
            return { username, nickname, password, type, ispassword, token, avatar, job }
        } else {
            console.log('decry fail:', { username, nickname, password, type, ispassword, token, d })
            console.error('decry fail:', username, nickname, password, type, ispassword, token, d)
            return false
        }
    }
    console.error('decry fail:', url)
    return false
}


export default decry